import React, { ReactElement } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { Outlet, useLocation } from 'react-router-dom';
import { zodResolver } from '@hookform/resolvers/zod';
import { EAppRoutes } from '@common/enums';
import { BulkDealsEditForm } from '@features/bulk-edit/interfaces';
import { TargetingContextProvider } from '@features/targeting/hooks/useTargetingContextProvider';
import { bulkEditSchema } from './schemas';

export const BulkDealRouteWithContext = (): ReactElement => {
  const location = useLocation();

  const formMethods = useForm<BulkDealsEditForm>({
    mode: 'all',
    reValidateMode: 'onChange',
    resolver: zodResolver(bulkEditSchema),
    defaultValues: {
      replaceCurrentDsps: false,
      removeAllOptimization: false,
      deals: {},
      optimization: {
        audiences: {},
        locations: { items: [] },
        targeting: {
          geographical: {},
          pointOfInterest: [],
          dayPartingPanel: [],
          videoPlacement: {},
          bannerPlacement: {},
          creativeAudio: {},
          creativeNative: {},
          creativeVideo: {},
          creativeBanner: {},
          verifiedSource: {},
          supplySource: {},
          deviceType: {},
          browser: {},
          operatingSystem: {},
          carrier: {},
          frequency: {},
          appSiteList: {},
          deals: {},
        },
      },
    },
  });

  const clearLastUpdatedCategory = location.pathname === EAppRoutes.TargetingBulkEditDeals;

  return (
    <FormProvider {...formMethods}>
      <TargetingContextProvider clearLastUpdatedCategory={clearLastUpdatedCategory}>
        <Outlet />
      </TargetingContextProvider>
    </FormProvider>
  );
};
